import { Injectable } from '@angular/core';
import { SearchResultFactoryService } from '@df/search/search-result-factory.service';
import { Search } from '@df/search/search.interfaces';
import { LocalSearchResult } from './search-result.decorator';
@Injectable()
export class LocalSearchResultFactoryService extends SearchResultFactoryService {
    override create(term: string, data: Search.IResult, options: Search.ISearchResultOptions) {
        return new LocalSearchResult(term, data, options);
    }
}
